import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Affiliate, User } from '../../../_models';
import { AffiliateService, AuthenticationService, KeywordService, NotificationService, UserService } from '../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-affiliate-list',
  templateUrl: './affiliate-list.component.html'
})
export class AffiliateListComponent implements OnInit {

  newAffiliateForm: FormGroup;
  keyWordId: string;
  keyword: any = {}; //Keyword
  affiliates: Affiliate[];
  currentUser: User;
  loaded = false;
  loading = false;
  processing = false;
  itemsPerPage=  20;
  pagingList = [ 20, 40, 60, 80, 100 ];
  totalItems = 0;
  maxSize = 10;
  numPages = 0;
  currentPage = 1;
  goToPage: number;
  emptyResult = false;
  showError = false;
  page: number;
  maxPageSize: number;
  affiliateFilter: string = null;
  clientList: any = [];

  initialized = false;

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private userSvc: UserService,
    private router: Router,
    private affiliateSvc: AffiliateService,
    private keywordSvc: KeywordService,
    private notification: NotificationService,
    private modalService: NgbModal,
    private authSvc: AuthenticationService) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.keyWordId = this.route.snapshot.paramMap.get('id');
    this.loadDetail(this.keyWordId);
    this.loadPage();
  }

  private loadDetail(id){
    this.keywordSvc.getKeyword(id).subscribe(data => {
      this.keyword = data
    });
  }

  back() {
    this.router.navigate(['/dashboard/keyword', {source: this.keyword.source, country: this.keyword.country, shortCode: this.keyword.shortCode, keyword: this.keyword.keyword, operator: this.keyword.operator}]);
  }

  openModal(targetModal, keyword = null) {
    if(this.initialized == false){
      this.loadClients();
      this.initialized = true;
    }

    this.processing = false;
    this.modalService.open(targetModal, {
     windowClass: 'modal-holder',
     size: 'lg'
    });

    this.newAffiliateForm = this.fb.group({
      affiliate: ['', Validators.required],
      cnvMin: [0, Validators.required],
      cnvCap: [0, Validators.required],
      cnvUrl: [''],
      dnMin: [0, Validators.required],
      dnCap: [0, Validators.required],
      dnNotifyUrl: [''],
      mgPremiumUrl: [''],
      moMin: [0, Validators.required],
      moCap: [0, Validators.required],
      moNotifyUrl: [''],
      managerId: [''],
      share: [''],
      moPostBackRate:[100, Validators.required],
      dnPostBackRate:[100, Validators.required],
      cnvPostBackRate:[100, Validators.required],
    });
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newAffiliateForm.getRawValue();
    if(this.newAffiliateForm.valid){
      if(confirm("Are you sure to add the affiliate now?")){
        this.affiliateSvc.addAffiliate(this.keyWordId, newDataParam).subscribe(data => {
          if(data !== null){
            if(data.status == 1){
              this.notification.showSuccess("Affiliate added successfully!", "New Affiliate");
              this.modalService.dismissAll();
              this.loadPage();
            }else{
              this.notification.showError(data.msg, "Fail to add");
            }

          }else{
            this.notification.showError("Failed to add affiliate, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    }else{
      this.showError = true;
      this.notification.showError("Some fields are missing, please check all the mandatory field", "Add failed");
      this.processing = false;
    }
  }

  deleteAffiliate(affiliate){
    if(confirm("Are you sure to delete this affiliate?")){
      this.affiliateSvc.deleteAffiliate(affiliate.id).subscribe(data => {
        if(data.status == 1){
          this.notification.showSuccess("Affiliate deleted successfully!", "Delete Affiliate");
          this.loadPage();
        }else{
          this.notification.showError("Error deleting affiliate, please try again later.", "Error");
        }
      })
    }
  }

  get f() { return this.newAffiliateForm.controls; }

  private loadClients(){
    this.userSvc.getAllClients().pipe(first()).subscribe(data => {
      this.clientList = data.data;
    });
  }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if(this.page != this.currentPage){
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  private loadPage(page = null){
    this.loading = true;
    this.affiliates = [];
    let id = this.keyWordId;
    let params = {
      affiliate: this.affiliateFilter,
      page: page == null ? this.currentPage - 1 : page - 1,
      pageSize: this.itemsPerPage || 20,
    }
    this.affiliateSvc.getAll(id, params).subscribe(data => {
      if(data !== null){
        this.affiliates = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
        this.loaded = true;
        this.loading = false;
        this.emptyResult = false;
      }else{
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no affiliate for this keyword.", "Empty Result");
      }
    });
  }

}
